const styles = theme => ({
  disabledTextWrapper: {
    display: 'inline-flex',
    width: '100%'
  },
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      marginBottom: 0
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionTitle: {
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  caption: {
    display: "block",
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  divider: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  sectionForm: {
    flexGrow: 2
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  inputContainerRadio: {
    marginLeft: "2rem"
  },
  checkboxContainer: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1)
    }
  },
  differentCheckboxContainer: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1)
    }
  },
  sideMargins: {
    [theme.breakpoints.up("md")]: {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2)
    }
  },
  storeOrderSummary: {
    margin: theme.spacing(2),
    marginTop: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default
  },
  summarySection: {
    padding: theme.spacing(2)
  },
  shippingAddress: {
    whiteSpace: "pre-line"
  },
  summaryHeading: {
    marginBottom: theme.spacing(0.5),
    fontWeight: 600
  },
  equipmentHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-start",
      flexDirection: "column"
    }
  },
  equipmentEditButton: {
    flexShrink: 0,
    textTransform: "none",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  equipmentEmptyState: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  equipmentEditor: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5)
  },
  equipmentEditorHint: {
    padding: theme.spacing(2),
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    textAlign: "center"
  },
  equipmentCard: {
    padding: theme.spacing(1.5),
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper
  },
  equipmentCardFields: {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 2fr) minmax(180px, 1.4fr) 110px auto",
    alignItems: "start",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr 1fr"
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr"
    }
  },
  equipmentQuantity: {
    minWidth: 100,
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  equipmentDeleteButton: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.error.main,
    [theme.breakpoints.down("sm")]: {
      justifySelf: "end"
    },
    [theme.breakpoints.down("xs")]: {
      justifySelf: "stretch",
      border: `1px solid ${theme.palette.error.light}`,
      borderRadius: theme.shape.borderRadius
    }
  },
  equipmentAddPanel: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(2),
    borderStyle: "dashed",
    backgroundColor: theme.palette.action.hover
  },
  equipmentAddTitle: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 600
  },
  equipmentAddButton: {
    minHeight: 40,
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      justifySelf: "stretch"
    }
  },
  equipmentError: {
    display: "block",
    marginTop: theme.spacing(1.5)
  },
  summaryList: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  summaryItem: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    minHeight: theme.spacing(3),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-start",
      flexDirection: "column",
      gap: 0
    }
  },
  summaryLink: {
    fontSize: theme.typography.body2.fontSize,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  signatureContainer: {
    border: "solid 1px rgba(0, 0, 0, 0.87)",
    borderRadius: 4,
    width: "calc(50% - 32px)",
    height: 150,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 32px)"
    }
  },
  signaturePad: {
    width: "100%",
    height: "100%"
  },
  clearButton: {
    marginLeft: theme.spacing(2),
    textTransform: "normal"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  error: {
    color: "red"
  },
  termsError: {
    marginLeft: theme.spacing(2)
  },
  signatureError: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  alignRight: {
    textAlign: "right"
  },
  table: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  },
  option: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: theme.spacing(2),
    border: "solid 1px rgba(0, 0, 0, 0.38)",
    borderRadius: 5
  },
  rate: {
    marginLeft: theme.spacing(2)
  }
});

export default styles;
